import { render, staticRenderFns } from "./CommentSection.vue?vue&type=template&id=bf462970&scoped=true"
import script from "./CommentSection.vue?vue&type=script&lang=js"
export * from "./CommentSection.vue?vue&type=script&lang=js"
import style0 from "./CommentSection.vue?vue&type=style&index=0&id=bf462970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf462970",
  null
  
)

export default component.exports